import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

const fmtDay = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });

export default function ViewCounter() {
  const { getToken } = useAuth();
  const [days, setDays] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/admin/views`, {
          params: { tz: TZ, days: 14 },
          headers: { Authorization: `Bearer ${await getToken()}` },
        });
        setDays(data.days);
      } catch {
        setError("Could not load views. Please refresh.");
      }
    })();
  }, [getToken]);

  if (error) return <p className="dream-error" data-testid="views-error">{error}</p>;
  if (!days) return <p className="muted" data-testid="views-loading">Counting the seekers…</p>;

  const today = days[0];
  const max = Math.max(1, ...days.map((d) => d.people_opened));
  return (
    <section className="views-panel" data-testid="views-panel">
      <h2 className="views-title">Visitors</h2>
      <div className="buyers-stats">
        <div data-testid="views-today-opened"><strong>{today.people_opened}</strong> opened today</div>
        <div data-testid="views-today-entered"><strong>{today.people_entered}</strong> pressed Enter today</div>
        <div data-testid="views-14d-opened"><strong>{days.reduce((s, d) => s + d.people_opened, 0)}</strong> visits in 14 days</div>
      </div>
      <div className="views-table-wrap buyers-table-wrap">
        <table className="buyers-table views-table" data-testid="views-table">
          <thead><tr><th>Day</th><th>People opened</th><th>Pressed Enter</th><th className="views-bar-col" /></tr></thead>
          <tbody>
            {days.map((d) => (
              <tr key={d.day} data-testid={`views-row-${d.day}`}>
                <td>{fmtDay(d.day)}</td>
                <td>{d.people_opened}</td>
                <td>{d.people_entered}</td>
                <td className="views-bar-col">
                  <div className="views-bar"><span style={{ width: `${(d.people_opened / max) * 100}%` }} /><span className="enter" style={{ width: `${(d.people_entered / max) * 100}%` }} /></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
